import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errText } from "../../../lib/api";
import { Trash, Plus } from "@phosphor-icons/react";

export const DepartmentsSection = () => {
  const [deps, setDeps] = useState([]);
  const [newDep, setNewDep] = useState("");

  const load = () => api.get("/departments").then((r) => setDeps(r.data));
  useEffect(() => { load(); }, []);

  const addDep = async (e) => {
    e.preventDefault();
    try {
      await api.post("/departments", { name: newDep });
      toast.success("Department added");
      setNewDep(""); load();
    } catch (err) { toast.error(errText(err)); }
  };

  const delDep = async (id) => {
    await api.delete(`/departments/${id}`);
    toast.success("Department removed");
    load();
  };

  return (
    <section className="bg-white border border-stone-200 rounded-lg p-6 space-y-4">
      <h3 className="font-heading font-bold">Departments</h3>
      <div className="flex flex-wrap gap-2">
        {deps.map((d) => (
          <span key={d.id} className="flex items-center gap-2 pl-4 pr-2 py-2 rounded-full bg-stone-100 text-sm font-semibold" data-testid={`department-chip-${d.name}`}>
            {d.name}
            <button onClick={() => delDep(d.id)} data-testid={`delete-department-${d.id}`} className="w-6 h-6 flex items-center justify-center rounded-full text-stone-400 hover:text-red-600 transition-colors duration-200"><Trash size={14} /></button>
          </span>
        ))}
      </div>
      <form onSubmit={addDep} className="flex gap-3">
        <input required placeholder="New department name" value={newDep} onChange={(e) => setNewDep(e.target.value)} data-testid="new-department-input"
          className="flex-1 min-h-[44px] px-3 rounded-lg border border-stone-300 focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary" />
        <button type="submit" data-testid="add-department-button" className="tap-scale flex items-center gap-1 px-5 py-2.5 rounded-full bg-primary text-white text-sm font-bold hover:bg-[#A63F07] transition-colors duration-200"><Plus size={16} weight="bold" /> Add</button>
      </form>
    </section>
  );
};
